import { observable, set } from 'mobx';

export interface ISalon {
  doorAddress: string;
  doorCity: string;
  salonId: string;
  doorName: string;
  doorState: string;
}

class Salon {
  @observable doorAddress: string;

  @observable doorCity: string;

  @observable salonId: string;

  @observable doorName: string;

  @observable doorState: string;

  static fromJSON(data: ISalon): Salon {
    const salon = new Salon();
    set(salon, data);

    return salon;
  }
}

export default Salon;
